import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  Container,
  Row,
  Col,
  Button,
  Modal,
  Form,
} from "react-bootstrap";

import { becomeFeatureDealer } from "../../Store/actions/index";

export default function BecomeFeature() {
  const [purchase, setPurchase] = useState({
    show: false,
    validity: "",
    error: false,
  });
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.Auth);
  const dealrship = currentUser
    ? currentUser.latest_featured_dealer_deal
    : null;

  return (
    <Container className="my-5">
      <Row>
        <Col>
          <h3 className="">Build Your Brand</h3>
          <p>
            Build your brand with your dealer profile page and customer reviwes
            on the main page of pcari | Auto and website.
          </p>
          <p>
            Build consumer trust by sharing your customer's reviews on your
            advers and dealer profile page.
          </p>
        </Col>
      </Row>

      {
        /*Featured Seller */
        currentUser && currentUser.is_featured && dealrship && (
          <Card className="border-0 shadow-sm">
            <Card.Header className="bg-white">
              <Card.Title>Featured</Card.Title>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col>
                  <p>
                    Your Featured Dealer privilege is valid for{" "}
                    {dealrship.validity_period} days
                  </p>
                  <p>Start: {dealrship.start_date.slice(0, -3)}</p>
                  <p>End: {dealrship.end_date.slice(0, -3)}</p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button
                    variant="primary"
                    className="text-white shadow-none"
                    onClick={(e) =>
                      setPurchase((prev) => {
                        return {
                          ...prev,
                          show: true,
                        };
                      })
                    }
                  >
                    Extend
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        )
      }

      {
        /*Unfeatured Seller */
        currentUser && !currentUser.is_featured && (
          <Card className="border-0 shadow-sm my-3">
            <Card.Header className="bg-white">
              <Card.Title>Featured</Card.Title>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col>
                  <p>You don't have Featured Dealer privilege.</p>
                  <p>Start: N/A</p>
                  <p>End: N/A</p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button
                    variant="primary"
                    className="text-white shadow-none"
                    onClick={(e) =>
                      setPurchase((prev) => {
                        return {
                          ...prev,
                          show: true,
                        };
                      })
                    }
                  >
                    Purchase
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        )
      }

      <Modal
        show={purchase.show}
        onHide={(e) =>
          setPurchase((prev) => {
            return {
              ...prev,
              show: false,
            };
          })
        }
      >
        <Modal.Header>
          <Modal.Title>Purchase</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Purchase Featured Dealer privileges</Form.Label>
            <Form.Control
              as="select"
              value={purchase.validity}
              isInvalid={purchase.error}
              onChange={(e) =>
                setPurchase((prev) => {
                  return {
                    ...prev,
                    validity: e.target.value,
                  };
                })
              }
            >
              <option hidden value>
                Select
              </option>
              <option value="14">14 days for RM50 </option>
              <option value="30">30 days for RM100 </option>
              <option value="90">90 days for RM150 </option>
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              Please select an option
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="text-white"
            onClick={(e) => {
              if (purchase.validity === "") {
                setPurchase((prev) => {
                  return { ...prev, error: true };
                });
              } else {
                setPurchase({
                  show: false,
                  validity: "",
                  error: false,
                });
                dispatch(becomeFeatureDealer(purchase.validity));
              }
            }}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
